/* Halloween extras: eyes that follow the pointer, "Buh!" after add-to-cart, spider on a thread. */
(() => {
  const root = document.querySelector('.hk-extras');
  if (!root || !root.animate) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reducedMotion.matches) return;

  const lowLayer = root.querySelector('.hk-extras__low');
  const highLayer = root.querySelector('.hk-extras__high');
  const random = (min, max) => min + Math.random() * (max - min);
  const fromTemplate = (name) =>
    root.querySelector(`template[data-hk-template="${name}"]`).content.firstElementChild.cloneNode(true);
  const removeWhenDone = (animation, element) => {
    animation.onfinish = () => element.remove();
    animation.oncancel = () => element.remove();
  };

  /* ---------- Eyes ---------- */
  function initEyes() {
    const eyeSets = [...document.querySelectorAll('[data-hk-eyes]')];
    if (!eyeSets.length) return;

    const visible = new Set();
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => (entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target)));
    });
    eyeSets.forEach((set) => observer.observe(set));

    let target = null;
    let frame = null;
    let lastInput = 0;

    function lookAt(x, y) {
      visible.forEach((set) => {
        set.querySelectorAll('.hk-eye').forEach((eye) => {
          const pupil = eye.querySelector('.hk-eye__pupil');
          const box = eye.querySelector('.hk-eye__white').getBoundingClientRect();
          const dx = x - (box.left + box.width / 2);
          const dy = y - (box.top + box.height / 2);
          const distance = Math.hypot(dx, dy) || 1;
          const reach = Number(pupil.dataset.hkRange) * Math.min(1, distance / 150);
          pupil.style.transform = `translate(${((dx / distance) * reach).toFixed(2)}px, ${(
            (dy / distance) *
            reach
          ).toFixed(2)}px)`;
        });
      });
    }

    function onPointer(event) {
      target = { x: event.clientX, y: event.clientY };
      lastInput = performance.now();
      eyeSets.forEach((set) => set.classList.toggle('is-wide', !!event.target.closest?.('.product-form__submit')));
      if (!frame) {
        frame = requestAnimationFrame(() => {
          frame = null;
          lookAt(target.x, target.y);
        });
      }
    }

    // pointermove fires for the mouse and for a finger dragging on touch screens; pointerdown catches single taps.
    window.addEventListener('pointermove', onPointer, { passive: true });
    window.addEventListener('pointerdown', onPointer, { passive: true });

    // Look around on their own after a few seconds without input.
    setInterval(() => {
      if (document.hidden || performance.now() - lastInput < 3000) return;
      lookAt(random(0, window.innerWidth), random(0, window.innerHeight));
    }, 1600);

    // Blink at random intervals.
    (function scheduleBlink() {
      setTimeout(() => {
        visible.forEach((set) => {
          set.querySelectorAll('.hk-eye__lid').forEach((lid) => {
            lid.classList.remove('is-blinking');
            void lid.getBoundingClientRect();
            lid.classList.add('is-blinking');
          });
        });
        scheduleBlink();
      }, random(3000, 7000));
    })();
  }

  /* ---------- "Buh!" after add-to-cart ---------- */
  function initBoo() {
    if (root.dataset.boo !== 'true' || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    let texts = [];
    try {
      texts = JSON.parse(root.dataset.booTexts || '[]')
        .map((text) => text.trim())
        .filter(Boolean);
    } catch (error) {}
    let lastText = -1;

    // Random line from the theme setting, never the same one twice in a row.
    function pickText() {
      if (texts.length < 2) return texts[0] || '';
      let index;
      do {
        index = Math.floor(Math.random() * texts.length);
      } while (index === lastText);
      lastText = index;
      return texts[index];
    }

    let lastButton = null;
    document.addEventListener(
      'click',
      (event) => {
        const button = event.target.closest?.('.product-form__submit');
        if (button) lastButton = button;
      },
      true
    );

    function releaseBats() {
      const rect = lastButton?.isConnected ? lastButton.getBoundingClientRect() : null;
      const originX = rect ? rect.left + rect.width / 2 : window.innerWidth / 2;
      const originY = rect ? rect.top + rect.height / 2 : window.innerHeight * 0.8;
      const count = Math.round(random(5, 7));

      for (let i = 0; i < count; i++) {
        const bat = fromTemplate('bat');
        highLayer.appendChild(bat);
        const dx = random(-180, 180);
        const dy = random(-340, -140);
        const turn = random(-25, 25);
        const animation = bat.animate(
          [
            { transform: `translate(${originX - 18}px, ${originY - 9}px) scale(0.3)`, opacity: 0 },
            { opacity: 1, offset: 0.15 },
            { opacity: 1, offset: 0.75 },
            {
              transform: `translate(${originX - 18 + dx}px, ${originY - 9 + dy}px) scale(${random(0.8, 1.2)}) rotate(${turn}deg)`,
              opacity: 0,
            },
          ],
          { duration: random(1100, 1600), delay: i * 60, easing: 'cubic-bezier(0.2, 0.7, 0.3, 1)', fill: 'both' }
        );
        removeWhenDone(animation, bat);
      }
    }

    function showGhost() {
      highLayer.querySelector('.hk-boo')?.remove();
      const boo = fromTemplate('boo');
      boo.querySelector('.hk-boo__bubble').textContent = pickText();
      highLayer.appendChild(boo);
      const animation = boo.animate(
        [
          { transform: 'translateY(40px) scale(0.3)', opacity: 0 },
          { transform: 'scale(1.08)', opacity: 1, offset: 0.12, easing: 'ease-out' },
          { transform: 'scale(1)', opacity: 1, offset: 0.18 },
          { transform: 'scale(1)', opacity: 1, offset: 0.85, easing: 'ease-in' },
          { transform: 'translateY(-40px) scale(0.7)', opacity: 0 },
        ],
        { duration: 2800, fill: 'both' }
      );
      removeWhenDone(animation, boo);
    }

    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.source !== 'product-form') return;
      releaseBats();
      showGhost();
    });
  }

  /* ---------- Spider on a thread ---------- */
  function initSpider() {
    if (root.dataset.spider !== 'true') return;

    let nextAllowed = performance.now() + 8000;
    let busy = false;

    function drop() {
      const spider = fromTemplate('spider');
      const width = window.innerWidth;
      const height = window.innerHeight;
      const header = document.querySelector('.section-header');
      const headerBottom = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;

      // Keep out of the central content column on larger screens.
      let x = random(0.04, 0.9) * width;
      if (width >= 750) x = Math.random() < 0.5 ? random(0.03, 0.28) * width : random(0.72, 0.95) * width;

      const hangAt = headerBottom + random(height * 0.08, height * 0.28);
      spider.style.left = `${x.toFixed(0)}px`;
      lowLayer.appendChild(spider);

      const animation = spider.animate(
        [
          { transform: 'translateY(-80px)', easing: 'cubic-bezier(0.3, 0.6, 0.4, 1)' },
          { transform: `translateY(${hangAt + 10}px)`, offset: 0.22, easing: 'ease-in-out' },
          { transform: `translateY(${hangAt - 4}px)`, offset: 0.28, easing: 'ease-in-out' },
          { transform: `translateY(${hangAt}px)`, offset: 0.33 },
          { transform: `translateY(${hangAt}px)`, offset: 0.72, easing: 'cubic-bezier(0.5, 0, 0.8, 0.4)' },
          { transform: 'translateY(-80px)' },
        ],
        { duration: 7500, fill: 'both' }
      );
      animation.onfinish = animation.oncancel = () => {
        spider.remove();
        busy = false;
      };
    }

    window.addEventListener(
      'scroll',
      () => {
        if (busy || document.hidden || performance.now() < nextAllowed) return;
        busy = true;
        nextAllowed = performance.now() + random(40000, 90000);
        setTimeout(drop, random(300, 1500));
      },
      { passive: true }
    );
  }

  initEyes();
  initBoo();
  initSpider();
})();
